import React, { Component } from "react";
import classnames from "classnames";
import { addMinutes, subSeconds } from "date-fns";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { duration } from "@formant/core/model/duration";
import { IEvent } from "@formant/core/model/IEvent";
import { IEventOrAggregate } from "@formant/core/model/IEventOrAggregate";
import { IEventQuery } from "@formant/core/model/IEventQuery";
import { IFilter } from "@formant/core/model/IFilter";

import { eventStore, observeStore } from "../../stores";
import { Timer } from "../common/Timer";
import { RecentEvent } from "./RecentEvent";
import * as styles from "./RecentEvents.scss";

export interface IRecentEventsProps {
    filter: IFilter;
    className?: string;
    onSelect: (event: IEventOrAggregate) => void;
}

@observer
export class RecentEvents extends Component<IRecentEventsProps> {
    @observable
    private time = new Date();

    private events: IEvent[] = [];

    public render() {
        const { onSelect, className } = this.props;

        if (observeStore.eventSidebar === "open") {
            return false;
        }

        const events = eventStore.query(this.query) || this.events;
        this.events = events;

        return (
            <div className={classnames(styles["recent-events"], className)}>
                <Timer onTick={this.onTick} interval={5 * duration.second} />

                {events.map(event => (
                    <RecentEvent
                        key={event.id}
                        event={event}
                        onSelect={onSelect}
                    />
                ))}
            </div>
        );
    }

    private onTick = () => {
        this.time = new Date();
    };

    private get query(): IEventQuery {
        return {
            ...this.props.filter,
            viewed: false,
            start: subSeconds(this.time, 10).toISOString(),
            end: addMinutes(this.time, 1).toISOString(),
            eventTypes: [
                "datapoint-event",
                "triggered-event",
                "intervention-request",
                "custom",
                "stateful",
            ],
            notificationEnabled: true,
        };
    }
}
